var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _rect, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotBusParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2029,
    height: 1862,
    viewBox: "0 0 2029 1862",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1338.69 244.766L291.686 736.266L478.686 802.766L492.686 768.266H539.186L561.686 727.766L611.186 743.766L619.686 688.766L675.686 712.766L686.186 665.266L740.186 680.266L755.186 635.266L804.686 653.266L816.186 613.766H868.686L880.686 571.766L937.686 586.766L950.686 542.766L1001.19 555.766L1017.19 507.266L1072.19 526.766L1080.69 478.266L1133.19 492.266L1151.69 454.766L1197.69 466.266L1213.69 422.266L1262.19 433.266L1279.69 386.766L1322.69 395.266L1347.19 356.766L1395.69 362.266L1409.69 321.266L1456.69 338.266L1469.69 296.766L1338.69 244.766Z",
    fill: "#6CDD59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M550.473 1577.6L753.51 1574.48",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M597.545 1526.33L800.582 1523.21",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1729 315.095L501.924 1629.06L490.328 1637.14L237.684 1463.35L132.196 1375.13C104.721 1352.16 81.0508 1324.98 62.0635 1294.61C33.7078 1249.25 16.4604 1197.84 11.7244 1144.56L6.14209 1081.76C1.77451 1032.62 9.97866 983.182 29.9827 938.091C59.4915 871.574 112.867 818.538 179.571 789.454L292.954 740.018L458.815 799.433L446.582 814.767L461.067 851.459L1559.68 337.586L1514.76 223.809L1526.36 200.945L1833.24 58.7775C1894.37 34.644 1938.54 72.1991 1952.98 93.9934L1952.12 194.325L1844.67 311.449L1729 315.095Z",
    fill: "#D9D9D9",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M647.912 1474.54L850.95 1471.42",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M699.236 1419.26L902.274 1416.14",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M746.787 1366.25L949.825 1363.13",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M797.012 1316.07L1000.05 1312.96",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M844.578 1259.16L1047.62 1256.04",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M897.498 1207.92L1100.54 1204.8",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M945.58 1156.25L1148.62 1153.14",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M993.395 1103.92L1197.05 1097.44",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.04 1049.3L1246.07 1046.19",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M418.848 675.527L561.682 727.299",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M348.43 702.16L499.83 761.833",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.82 996.18L1297.86 993.061",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M485.115 644.305L629.006 696.13",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.15 945.98L1344.19 942.862",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M550.834 615.637L690.187 665.759",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M615.945 584.484L755.298 634.606",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M685.693 556.172L825.046 606.294",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M752.238 523.676L891.591 573.798",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M818.232 493.73L957.585 543.852",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M877.938 457.711L1017.29 507.833",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M948.096 428.453L1082.28 482.477",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.46 402.27L1151.81 452.391",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.84 373.293L1225.2 423.415",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.55 337.277L1284.9 387.399",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.95 309.488L1353.31 359.61",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1276.6 276.98L1415.95 327.102",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.39 891.906L1394.43 888.787",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1242.32 833.672L1445.36 830.553",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1292.41 785.105L1495.45 781.987",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.16 733.172L1544.2 730.053",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1385.37 677.59L1588.4 674.471",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1435.18 628.352L1638.22 625.233",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1489.59 574.969L1692.63 571.85",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1536.48 518.324L1739.52 515.205",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1590.75 466.555L1793.79 463.436",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1637.61 417.707L1840.65 414.588",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M459.548 800.305L478.807 806.709L492.509 763.558L537.98 769.341L561.48 729.326L610.69 740.636C613.054 722.972 619.39 688.955 625.818 694.199C632.246 699.443 661.722 710.243 675.657 714.987L690.785 668.55L738.985 680.259L757.4 635.248L802.943 655.009L822.704 609.467L870.531 614.319L885.979 571.647L938.191 587.607L953.639 544.935L1002.45 555.235L1015.7 507.983L1072.47 527.593L1079.66 482.733L1133.1 493.928L1153.38 453.63L1197.06 468.678L1214.01 419.964L1260.98 436.439L1279.28 387.194L1324.26 398.619L1346.94 360.482L1395.62 370.445L1410.75 324.008L1459.58 345.196L1474.7 298.759",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1476.45 299.236L1343.68 247.765L1338.24 233.964L1846.25 5L1889.78 8.82466C1920.83 11.5525 1949.63 26.1428 1970.19 49.5612L1979.89 60.602C2000.28 83.8261 2014.57 112.032 2021.34 142.187C2024.63 156.834 2024.27 172.181 2020.24 186.642C2012.73 213.566 1999.12 238.396 1980.45 259.203L1897.52 351.667L1696.13 361.917",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M457.465 799.965L446.508 815.574",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M645.585 1708.13L512.172 1621.51L679.066 1615.54L679.557 1615.84C689.265 1621.85 694.836 1632.43 694.684 1643.44C694.605 1649.09 691.525 1654.12 687.862 1658.43L645.585 1708.13Z",
    stroke: "#9C9C9C",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1638.19 629.266L1438.69 633.266L1401.69 672.766L1588.69 669.766L1638.19 629.266Z",
    fill: "#E13827"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 686,
    y: 1761.58,
    width: 454.149,
    height: 156.086,
    rx: 10,
    transform: "rotate(-50.1341 686 1761.58)",
    fill: "#FE763B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M776.975 1767.1L748.144 1746.05L758.14 1732.36C760.322 1729.37 762.781 1727.47 765.518 1726.67C768.686 1725.72 771.858 1726.41 775.035 1728.72C781.657 1733.56 782.432 1739.45 777.361 1746.4L772.849 1752.57L782.459 1759.59L776.975 1767.1ZM759.645 1742.93L767.034 1748.33L770.72 1743.28C772.686 1740.59 772.471 1738.37 770.075 1736.62C767.545 1734.77 765.297 1735.19 763.331 1737.88L759.645 1742.93Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M790.772 1726.25C792.36 1727.41 793.882 1728.07 795.337 1728.22C797.133 1728.42 798.562 1727.79 799.623 1726.34C800.685 1724.88 800.858 1723.32 800.144 1721.64C799.526 1720.28 798.437 1719.03 796.875 1717.89C795.314 1716.75 793.792 1716.09 792.31 1715.92C790.467 1715.73 789.015 1716.36 787.954 1717.82C786.892 1719.27 786.742 1720.83 787.504 1722.5C788.094 1723.84 789.183 1725.09 790.772 1726.25ZM785.759 1733.12C782.582 1730.8 780.691 1727.85 780.085 1724.27C779.472 1720.64 780.345 1717.21 782.704 1713.98C785.063 1710.75 788.063 1708.88 791.703 1708.36C795.317 1707.82 798.712 1708.71 801.888 1711.03C805.065 1713.35 806.946 1716.31 807.532 1719.92C808.118 1723.52 807.232 1726.94 804.873 1730.17C802.514 1733.4 799.528 1735.29 795.914 1735.83C792.321 1736.34 788.935 1735.44 785.759 1733.12Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M815.158 1714.82L794.2 1699.51L799.066 1692.85L802.74 1695.53L802.799 1695.45C800.827 1692.44 801.001 1689.35 803.321 1686.17C803.773 1685.56 804.22 1685.06 804.662 1684.68L810.921 1689.25C809.924 1690.05 809.151 1690.82 808.6 1691.58C807.421 1693.19 806.981 1694.81 807.282 1696.43C807.556 1698.04 808.393 1699.35 809.793 1700.37L820.17 1707.95L815.158 1714.82Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M827.536 1697.87L798.704 1676.81L803.717 1669.95L818.577 1680.8L816.162 1669.44L821.971 1661.48L824.283 1674.93L843.635 1675.82L837.591 1684.1L825.406 1683.06L825.845 1686.11L832.548 1691L827.536 1697.87Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M855.449 1620.72L849.965 1628.23C848.4 1627.38 846.858 1627.2 845.338 1627.7C843.81 1628.16 842.456 1629.19 841.277 1630.81C839.626 1633.07 839.256 1635.44 840.168 1637.92C840.955 1640.06 842.547 1642.01 844.942 1643.76C847.338 1645.51 849.677 1646.43 851.958 1646.53C854.6 1646.64 856.747 1645.57 858.398 1643.31C861.012 1639.73 860.651 1636.49 857.314 1633.6L862.798 1626.09C866.322 1628.95 868.239 1632.38 868.55 1636.36C868.88 1640.31 867.689 1644.15 864.977 1647.86C861.851 1652.15 857.851 1654.57 852.978 1655.14C848.245 1655.69 843.738 1654.4 839.458 1651.27C835.178 1648.15 832.574 1644.22 831.647 1639.5C830.713 1634.73 831.808 1630.21 834.934 1625.93C837.372 1622.59 840.466 1620.33 844.218 1619.15C848.343 1617.91 852.086 1618.43 855.449 1620.72Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M876.69 1630.55L847.859 1609.5L852.872 1602.63L863.613 1610.48L863.672 1610.4C862.995 1609.12 862.796 1607.61 863.074 1605.87C863.32 1604.24 863.915 1602.77 864.858 1601.48C868.534 1596.45 873.078 1595.91 878.488 1599.86L891.935 1609.68L886.922 1616.54L876.787 1609.14C874.714 1607.63 873.316 1606.77 872.594 1606.57C871.068 1606.12 869.705 1606.71 868.506 1608.36C867.622 1609.57 867.391 1610.84 867.815 1612.18C868.19 1613.37 869.01 1614.42 870.275 1615.34L881.703 1623.69L876.69 1630.55Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M889.081 1591.63C890.669 1592.79 892.191 1593.44 893.646 1593.6C895.442 1593.79 896.871 1593.17 897.933 1591.71C898.994 1590.26 899.167 1588.69 898.453 1587.02C897.835 1585.66 896.746 1584.41 895.185 1583.27C893.623 1582.13 892.101 1581.47 890.619 1581.3C888.776 1581.11 887.324 1581.74 886.263 1583.19C885.201 1584.64 885.051 1586.21 885.813 1587.88C886.403 1589.22 887.492 1590.47 889.081 1591.63ZM884.068 1598.49C880.891 1596.17 879 1593.22 878.395 1589.64C877.782 1586.02 878.655 1582.59 881.014 1579.36C883.372 1576.13 886.372 1574.25 890.012 1573.73C893.626 1573.19 897.021 1574.08 900.197 1576.4C903.374 1578.72 905.255 1581.69 905.841 1585.29C906.427 1588.9 905.541 1592.32 903.182 1595.55C900.823 1598.78 897.837 1600.66 894.223 1601.2C890.63 1601.71 887.244 1600.81 884.068 1598.49Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M904.879 1557.7C904.073 1558.8 903.785 1560.02 904.015 1561.34C904.323 1563.01 905.46 1564.56 907.425 1566C911.463 1568.95 914.494 1569.03 916.519 1566.26C917.541 1564.86 917.682 1563.31 916.94 1561.61C916.269 1560.22 915.112 1558.92 913.47 1557.72C911.935 1556.6 910.454 1555.97 909.025 1555.84C907.283 1555.68 905.901 1556.3 904.879 1557.7ZM920.316 1585.56L892.333 1565.13L897.11 1558.59L899.532 1560.36L899.591 1560.28C898.575 1557.43 898.971 1554.77 900.779 1552.29C903.04 1549.19 905.964 1547.68 909.552 1547.74C912.733 1547.79 915.939 1549 919.169 1551.36C922.103 1553.5 924.022 1556.01 924.926 1558.9C925.907 1562.14 925.376 1565.15 923.331 1567.95C921.464 1570.51 919.053 1571.81 916.1 1571.84L916.041 1571.92L925.329 1578.7L920.316 1585.56Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M941.312 1542.06L912.48 1521.01L917.965 1513.5L928.464 1521.16L935.688 1511.27L925.189 1503.6L930.674 1496.09L959.505 1517.15L954.02 1524.66L942.149 1515.99L934.924 1525.88L946.796 1534.55L941.312 1542.06Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M963.197 1512.09L942.24 1496.79L947.253 1489.92L968.21 1505.22L963.197 1512.09ZM939.379 1484.17L944.628 1488L939.615 1494.87L934.366 1491.04L939.379 1484.17Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M971.922 1500.14L943.091 1479.09L948.104 1472.22L976.935 1493.28L971.922 1500.14Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M980.647 1488.19L951.816 1467.14L956.829 1460.27L985.66 1481.33L980.647 1488.19Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M839.246 1765.51L845.868 1770.35L850.262 1764.33C852.228 1761.64 852.134 1759.5 849.98 1757.93C847.719 1756.28 845.606 1756.8 843.64 1759.49L839.246 1765.51ZM846.4 1782.25L817.569 1761.2L827.418 1747.71C832.49 1740.76 837.435 1739.05 842.254 1742.57C844.865 1744.48 845.879 1747.16 845.296 1750.61C846.848 1749.39 848.567 1748.79 850.454 1748.81C852.341 1748.82 854.105 1749.43 855.748 1750.63C861.724 1754.99 861.979 1760.92 856.514 1768.4L846.4 1782.25ZM828.869 1757.93L834.401 1761.97L838.647 1756.16C839.217 1755.38 839.506 1754.56 839.515 1753.7C839.542 1752.64 839.084 1751.77 838.142 1751.08C836.284 1749.73 834.609 1750.07 833.115 1752.12L828.869 1757.93Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M861.732 1717.25L882.689 1732.56L877.824 1739.22L874.957 1737.12L874.898 1737.2C875.476 1738.62 875.656 1740.15 875.437 1741.81C875.191 1743.45 874.616 1744.88 873.712 1746.12C871.628 1748.97 869.327 1750.43 866.807 1750.49C864.594 1750.52 862.02 1749.47 859.086 1747.33L846.488 1738.13L851.5 1731.26L863.655 1740.14C866.158 1741.97 868.236 1741.75 869.887 1739.49C870.575 1738.55 870.842 1737.5 870.687 1736.36C870.528 1734.88 869.614 1733.53 867.945 1732.31L856.72 1724.12L861.732 1717.25Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M878.258 1724.13L883.035 1717.58C884.031 1718.31 885.087 1718.5 886.203 1718.16C887.159 1717.87 888.02 1717.2 888.787 1716.15C889.377 1715.34 889.726 1714.53 889.836 1713.7C889.982 1712.65 889.679 1711.85 888.925 1711.3C888.225 1710.79 887.392 1710.8 886.425 1711.33C886.101 1711.55 885.379 1712.11 884.257 1713.03C882.853 1714.27 881.435 1715.51 880.004 1716.73C878.327 1718.07 876.817 1718.86 875.474 1719.12C873.738 1719.46 872.009 1719 870.286 1717.75C867.998 1716.08 867.088 1713.76 867.557 1710.8C867.907 1708.46 869.006 1706.02 870.854 1703.49C875.415 1697.24 880.025 1695.68 884.685 1698.79L880.056 1705.13C878.494 1703.99 876.967 1704.44 875.473 1706.49C874.038 1708.45 873.845 1709.82 874.895 1710.59C875.729 1711.2 877.061 1710.79 878.889 1709.36C880.431 1707.92 881.996 1706.49 883.585 1705.05C885.365 1703.46 887.231 1702.65 889.185 1702.63C890.684 1702.62 892 1703.02 893.13 1703.84C895.715 1705.73 896.87 1708.25 896.597 1711.39C896.376 1713.95 895.263 1716.61 893.258 1719.35C891.155 1722.23 888.949 1724.15 886.641 1725.11C883.803 1726.34 881.009 1726.01 878.258 1724.13Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M911.94 1692.5L883.109 1671.45L893.105 1657.76C895.287 1654.77 897.746 1652.87 900.483 1652.06C903.651 1651.12 906.823 1651.8 910 1654.12C916.622 1658.96 917.397 1664.85 912.326 1671.79L907.814 1677.97L917.424 1684.99L911.94 1692.5ZM894.61 1668.33L901.999 1673.72L905.685 1668.68C907.651 1665.99 907.436 1663.76 905.04 1662.01C902.51 1660.17 900.262 1660.59 898.296 1663.28L894.61 1668.33Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M930.09 1655.01C931.678 1656.17 933.17 1655.8 934.566 1653.88C935.745 1652.27 936.077 1650.8 935.56 1649.47C935.062 1648.12 933.694 1646.69 931.454 1645.17C931.409 1645.8 931.01 1646.91 930.257 1648.51C929.504 1650.11 929.065 1651.27 928.941 1652.01C928.738 1653.3 929.121 1654.3 930.09 1655.01ZM921.905 1648.42L917.217 1654.84C912.663 1651.18 912.725 1646.15 917.404 1639.74C919.566 1636.78 921.639 1634.85 923.62 1633.94C926.225 1632.75 928.874 1633.14 931.566 1635.1L940.732 1641.79C943.209 1643.6 945.195 1644.64 946.692 1644.91L941.65 1651.81C941.101 1651.66 940.344 1651.31 939.377 1650.77C939.9 1653.67 939.081 1656.6 936.919 1659.57C935.385 1661.66 933.635 1662.99 931.669 1663.53C929.536 1664.08 927.433 1663.6 925.36 1662.08C923.287 1660.57 922.237 1658.73 922.209 1656.56C922.168 1654.92 922.746 1652.89 923.941 1650.46C924.97 1648.49 925.988 1646.53 926.997 1644.58C927.639 1643.19 927.435 1642.11 926.385 1641.35C925.658 1640.82 924.818 1640.78 923.864 1641.24C923.088 1641.62 922.396 1642.23 921.787 1643.07C920.352 1645.03 920.391 1646.81 921.905 1648.42Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M949.575 1640.96L928.618 1625.66L933.484 1618.99L937.158 1621.68L937.217 1621.6C935.245 1618.59 935.419 1615.5 937.739 1612.32C938.191 1611.7 938.638 1611.2 939.08 1610.82L945.339 1615.39C944.342 1616.19 943.569 1616.97 943.018 1617.72C941.839 1619.34 941.399 1620.96 941.7 1622.58C941.974 1624.18 942.811 1625.5 944.211 1626.52L954.588 1634.1L949.575 1640.96Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M961.953 1624.01L933.122 1602.96L938.135 1596.09L952.995 1606.94L950.58 1595.58L956.389 1587.63L958.7 1601.08L978.053 1601.96L972.008 1610.24L959.824 1609.21L960.263 1612.25L966.966 1617.15L961.953 1624.01Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M979.609 1599.83L958.652 1584.53L963.665 1577.66L984.622 1592.97L979.609 1599.83ZM955.791 1571.91L961.04 1575.75L956.028 1582.61L950.778 1578.78L955.791 1571.91Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M988.158 1588.13L967.201 1572.82L972.066 1566.16L974.933 1568.25L974.992 1568.17C974.394 1566.79 974.238 1565.25 974.523 1563.56C974.781 1561.85 975.382 1560.35 976.326 1559.05C980.002 1554.02 984.545 1553.48 989.956 1557.43L1003.4 1567.25L998.39 1574.11L988.254 1566.71C986.182 1565.2 984.784 1564.34 984.061 1564.15C982.535 1563.69 981.173 1564.29 979.974 1565.93C979.089 1567.14 978.859 1568.42 979.282 1569.76C979.658 1570.94 980.478 1571.99 981.743 1572.92L993.17 1581.26L988.158 1588.13Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.76 1540.87C1004.25 1539.77 1002.83 1539.18 1001.48 1539.11C999.845 1539.03 998.507 1539.7 997.465 1541.13C996.443 1542.53 996.228 1543.98 996.821 1545.49C997.323 1546.72 998.315 1547.88 999.795 1548.96C1001.17 1549.96 1002.52 1550.48 1003.87 1550.51C1005.4 1550.55 1006.65 1549.92 1007.61 1548.6C1008.61 1547.23 1008.91 1545.81 1008.49 1544.35C1008.1 1543.07 1007.19 1541.91 1005.76 1540.87ZM1000.58 1527.12L1018.99 1540.56C1025.58 1545.38 1026.34 1551.27 1021.25 1558.25C1019.16 1561.1 1017.12 1563.02 1015.13 1563.99C1012.56 1565.25 1009.86 1565.14 1007.02 1563.65L1012.04 1556.78C1013.74 1557.62 1015.39 1556.94 1016.98 1554.76C1018.06 1553.28 1018.31 1551.92 1017.74 1550.67C1017.31 1549.78 1016.31 1548.76 1014.72 1547.6L1012.74 1546.15L1012.68 1546.23C1013.76 1549.05 1013.43 1551.65 1011.68 1554.05C1009.46 1557.09 1006.76 1558.69 1003.59 1558.85C1000.68 1559 997.663 1557.93 994.54 1555.65C991.633 1553.52 989.803 1550.97 989.052 1547.99C988.271 1544.82 988.923 1541.8 991.007 1538.95C992.855 1536.42 995.298 1535.34 998.336 1535.7L998.395 1535.62L995.77 1533.7L1000.58 1527.12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotBusParking);
export default __webpack_public_path__ + "static/media/LotBusParking.96349800cf21bcae5591201cb63afd0a.svg";
export { ForwardRef as ReactComponent };